import { ArrowRight } from "lucide-react";
import { Reveal, Overline } from "./motion";
import { MANIFESTO } from "./content";

export const Manifesto = () => (
  <section id="universo" className="relative bg-dm-cream py-24 md:py-32">
    <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-12 px-5 md:px-8 lg:grid-cols-12 lg:gap-8">
      {/* Sticky left */}
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Overline color="#FF4D85">O manifesto</Overline>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display text-5xl font-black leading-[0.9] tracking-tighter text-dm-ink md:text-6xl lg:text-7xl">
              Menos tela.
              <br />
              <span className="dm-rainbow-text">Mais mundo.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 max-w-md text-lg leading-relaxed text-dm-muted">
              Nosso ponto de partida é uma inquietação: a infância virou plateia. A DóRéMigos
              existe para devolver o protagonismo à criança — com música na mão, no corpo e na
              roda de amigos.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 inline-flex items-center gap-3 rounded-2xl bg-dm-guita p-[2px]">
              <div className="rounded-[14px] bg-dm-cream px-6 py-4">
                <p className="max-w-xs font-display text-lg font-bold leading-snug text-dm-ink">
                  Uma marca 360º: história, produto e experiência falando a mesma língua.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>

      {/* Right: numbered chapters */}
      <div className="lg:col-span-7">
        <div className="flex flex-col gap-4">
          {MANIFESTO.map((item, i) => (
            <Reveal key={item.n} delay={i * 0.08}>
              <div className="group flex items-center gap-5 rounded-3xl border border-dm-ink/10 bg-white p-6 transition-all duration-500 hover:border-transparent hover:shadow-[0_24px_50px_rgba(0,0,0,0.08)] md:p-8">
                <span
                  className="font-display text-4xl font-black tabular-nums md:text-6xl"
                  style={{ color: item.color }}
                >
                  {item.n}
                </span>
                <div className="flex flex-1 flex-col gap-2 md:flex-row md:items-center md:gap-6">
                  <span className="text-base font-medium text-dm-muted line-through decoration-dm-ink/30 md:text-lg">
                    {item.from}
                  </span>
                  <ArrowRight className="hidden h-5 w-5 shrink-0 text-dm-ink/40 transition-transform duration-500 group-hover:translate-x-1 md:block" />
                  <span className="font-display text-xl font-bold text-dm-ink md:text-2xl">
                    {item.to}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
